import { fromJS } from 'immutable';

import { successAction, failAction, startAction } from 'actions/actionTypes';
import {
    AUTHENTICATED,
    LOGIN,
    LOGOUT,
    REFRESH_TOKEN,
    RESTORE_AUTH,
    VERIFY_MFA,
    VERIFY_MFA_SETUP,
} from 'actions/session';
import { UPDATE_PROFILE } from 'actions/users';

const defaultState = fromJS({ isLoggingIn: false, isLoggedIn: false });

export default function session(state = defaultState, action) {
    switch (action.type) {
        case startAction(LOGIN):
        case startAction(VERIFY_MFA):
        case startAction(VERIFY_MFA_SETUP):
            return fromJS({
                isLoggingIn: true,
                isLoggedIn: false,
            });
        case successAction(LOGIN): {
            const { data } = action.response;

            if (data.status && data.status !== AUTHENTICATED) {
                return fromJS({
                    isLoggingIn: false,
                    isLoggedIn: false,
                });
            }

            return fromJS({
                isLoggingIn: false,
                isLoggedIn: true,
                appToken: data,
            });
        }
        case successAction(VERIFY_MFA):
        case successAction(VERIFY_MFA_SETUP): {
            return fromJS({
                isLoggingIn: false,
                isLoggedIn: true,
                appToken: action.response.data,
            });
        }
        case RESTORE_AUTH: {
            return fromJS({
                isLoggingIn: false,
                isLoggedIn: true,
                appToken: JSON.parse(action.appToken),
            });
        }
        case LOGOUT:
        case failAction(LOGIN):
        case failAction(VERIFY_MFA):
        case failAction(VERIFY_MFA_SETUP):
        case failAction(REFRESH_TOKEN): {
            return fromJS({
                isLoggingIn: false,
                isLoggedIn: false,
            });
        }
        case successAction(REFRESH_TOKEN):
            return state.mergeIn(['appToken'], fromJS(action.response.data));
        case successAction(UPDATE_PROFILE):
            return state.mergeIn(['appToken', 'user'], fromJS(action.response.data));
        default:
            return state;
    }
}
